
<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <h2 class="color-gray header-card_title title-card u-medium f-20 pd-0" id="Consulta Afiliaciones Empleados">
        Gestion procesos masivos
      </h2>
    </mat-expansion-panel-header>
  
<app-affiliates-process [titleSite]="'Histórico de Afiliaciones Masivas'" [userloggedin] = userloggedin></app-affiliates-process>
<div class="header-card d-flex bottom-xs">
  <h2 class="color-gray header-card_title u-medium f-20">
    {{title}}
    
    <div class="tooltip right">
      <img src="./assets/icons/icon-interrogative.svg" id="IMG_Exclamation consulta masiva" alt="Icono exclamación">
      <span class="tiptext">Consulta aquí el estado de los procesos de Consulta Masiva de Trabajadores que hayas realizado.</span>
    </div>
  </h2>
</div>
<table aria-label="Tabla de consultas masivas" class="rwd-table" width="100%" height="100%" cellpadding="0" cellspacing="0" id="tableMass">
	<thead class="thead">
		<th class="text-gray-category color-gray">
			Código de proceso
		</th>

		<th class="text-gray-category color-gray">
			Fecha de proceso
		</th>

		<th class="text-gray-category color-gray">
			Estado en proceso
    </th>

    <th class="text-gray-category color-gray">
			Detalle
		</th>
  </thead>

  <tbody *ngIf="items as procesos">
		<tr *ngFor="let proceso of procesos">
			<td data-th="Código de proceso">
				<div>
          {{proceso?.data?.information?.code | uppercase}}
        </div>
			</td>

			<td data-th="Fecha de proceso">
				<div>
          {{proceso.timestamp | date:'dd/MM/yyyy'}}
        </div>
			</td>

      <td data-th="Estado en proceso"
          class="text-gray-category"
          [ngClass]="{
            'color-red': proceso.estado === 'FAILED',
            'color-blue': proceso.estado === 'PENDING',
            'color-green': proceso.estado === 'FINISHED'
          }"
      >
				<div>
            {{proceso.estado | formatStatus}}
        </div>
			</td>

			<td data-th="Detalle" class="text-gray-category color-gray">
        <div class="center">
          <button type="button" appDebounceClickGeneral tabindex="0"
              data-category = "Inicio"
              data-action = "Consultas masivas"
              data-label = "Descarga"
              data-event = "ga_event_descarga"
              *ngIf="proceso.estado == 'FINISHED' && proceso.data.information.url"
                (click)="downloadElement(proceso)" class="icon-download-hover btn-nav-proccess">
                <img  src="./assets/icons/Excel.svg"
                  alt="Ir a Descargar archivo de afiliación masiva con código de proceso {{proceso.data.information.code | uppercase}} fecha de proceso {{proceso.timestamp | date:'longDate'}} estado de proceso {{proceso.estado | formatStatus}}"/>
          </button>
          <button type="button" appDebounceClickGeneral tabindex="0"
              data-category = "Inicio"
              data-action = "Consultas masivas"
              data-label = "Descarga"
              data-event = "ga_event_descarga"
              (click)="showElement(proceso)" class="icon-download-hover btn-nav-proccess">
                <img  src="./assets/icons/icon-eye.svg"
                  alt="Visualizar datos de afiliación masiva con código de proceso {{proceso.data.information.code | uppercase}} fecha de proceso {{proceso.timestamp | date:'longDate'}} estado de proceso {{proceso.estado | formatStatus}}"/>
          </button>
          <!--
          <a appDebounceClickGeneral
              data-category="Inicio"
              data-action="Consultas masivas"
              data-label="Consultar"
              data-event="ga_event_consultar"
              class="icon-download-hover detail btn-nav-proccess" (click)="showElement(proceso);">
                <em aria-hidden="true" class="center material-icons color-blue-dark">visibility</em>
          </a>
          -->
        </div>
      </td>

    </tr>

    <div class="h-35"></div>
  </tbody>
</table>

  <!--<div class="content-card">

      <div *ngIf="items as procesos">
        <div *ngFor="let proceso of procesos" class="row-card-masive mt-masive">
          <span class="text-gray-category color-gray">
            {{proceso?.data?.information?.code | uppercase}}
          </span>

          <span class="text-gray-category color-gray">
            {{proceso.timestamp | date:'dd/MM/yyyy'}}
          </span>

          <span
            class="text-gray-category"
            [ngClass]="{
              'color-red': proceso.estado === 'FAILED',
              'color-blue': proceso.estado === 'PENDING',
              'color-green': proceso.estado === 'FINISHED'
            }">
            {{proceso.estado | formatStatus}}
          </span>

          <span class="text-gray-category color-gray">
            <a *ngIf="proceso.estado == 'FINISHED' && proceso.data.information.url" (click)="downloadElement(proceso)" class="icon-download-hover" title="Descargar archivo">
                <img src="./assets/icons/document-blue2.svg" alt="">
            </a>
            <button class="icon-download-hover" (click)="showElement(proceso);">
              <i class="material-icons color-blue-dark">visibility</i>
            </button>
          </span>

        </div>
      </div>
  </div>-->

  <div class="content-btn-detail">
    <button type="button" appDebounceClickGeneral
    data-category="Inicio"
    data-action="Consultas masivas"
    data-label="Ver más"
    data-event="ga_event_vermas"
    class="bnt-datail bnt-datail--blue btn-nav-proccess" (click)="openLink()">
      <!--<em class="material-icons">navigate_next</em>-->
      <span class="text-btn-datail">{{loading ? 'Consultando...' : 'Consultar otras afiliaciones'}}</span>
    </button>
  </div>
</mat-expansion-panel>
</mat-accordion>